import { render, staticRenderFns } from "./CardRejected.vue?vue&type=template&id=49da0a53&scoped=true"
import script from "./CardRejected.vue?vue&type=script&lang=js"
export * from "./CardRejected.vue?vue&type=script&lang=js"
import style0 from "./CardRejected.vue?vue&type=style&index=0&id=49da0a53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49da0a53",
  null
  
)

export default component.exports